import { FilterGroupingEnum, UserFilterInputObject } from 'graphql-common';

export type UserChipListRelationIds = {
  actionId?: string;
  departmentId?: string;
  interventionId?: string;
  sectorId?: string;
  siteId?: string;
  teamId?: string;
};

const RELATION_FILTER_FIELDS: Record<
  keyof UserChipListRelationIds,
  keyof UserFilterInputObject
> = {
  interventionId: 'interventionAssigneesInterventionId',
  actionId: 'interventionActionAssigneesActionId',
  teamId: 'teamId',
  departmentId: 'memberAssignedDepartmentsId',
  sectorId: 'memberAssignedSectorsId',
  siteId: 'memberAssignedSitesId',
};

export default function getUserChipListFilters(
  relationIds: UserChipListRelationIds,
): UserFilterInputObject[] {
  return (
    Object.keys(RELATION_FILTER_FIELDS) as (keyof UserChipListRelationIds)[]
  )
    .filter((relationKey) => relationIds[relationKey])
    .map((relationKey) => ({
      [RELATION_FILTER_FIELDS[relationKey]]: {
        grouping: FilterGroupingEnum.Or,
        predicate: { eq: relationIds[relationKey] },
      },
    }));
}
